import request from '@/utils/request'

// 房源出售
// 查询合同信息列表
export function contractsInfoSaleList (query) {
  return request({
    url: '/houses/houseInfoSale/list',
    method: 'get',
    params: query
  })
}
// 新增出售房源
export function addHouseInfoSale (data) {
  return request({
    url: '/houses/houseInfoSale/add',
    method: 'post',
    data: data
  })
}
// 查看房源信息（售）是否存在
export function searchHouseInfoSale (data) {
  return request({
    url: '/houses/houseInfoSale/get/houses/exists',
    method: 'post',
    data: data
  })
}
// 查看房源信息（售）是否存在
export function editHouseInfoSale (data) {
  return request({
    url: '/houses/houseInfoSale/edit',
    method: 'put',
    data: data
  })
}
// 获取房源的详细信息（售）
export function houseInfoSale (id) {
  return request({
    url: '/houses/houseInfoSale/' + id,
    method: 'get'
  })
}
// 修改标识状态：五，独，优，钥匙（售）
export function houseInfoSaleidentity (data) {
  return request({
    url: '/houses/houseInfoSale/edit/identity',
    method: 'post',
    data: data
  })
}
// 转维护人（售）
export function houseInfoSaleAccendant (data) {
  return request({
    url: '/houses/houseInfoSale/update/accendant',
    method: 'put',
    data: data
  })
}
// 新增实勘-编辑图片（售）
export function houseInfoSaleInvestigation (data) {
  return request({
    url: '/houses/houseInfoSale/update/investigation',
    method: 'put',
    data: data
  })
}
// 根据房源ID获取业主信息
export function getLessorByHouseId (query) {
  return request({
    url: '/lessorInfo/house/getLessorByHouseId',
    method: 'get',
    params: query
  })
}
// 房源一键同步
export function synchronization (data) {
  return request({
    url: '/houses/houseInfoSale/edit/synchronization',
    method: 'put',
    data
  })
}
